import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faCartArrowDown, faChartPie, faChevronDown, faClipboard, faCommentDots, faFileAlt, faPlus, faRocket, faStore, faUserShield, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Button, Dropdown, Card, Alert } from '@themesberg/react-bootstrap';
import { ChoosePhotoWidget, ProfileCardWidget } from "../components/Widgets";
import { GeneralInfoForm } from "../components/Forms";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useAuth } from '../contexts/AuthContext';

import Profile3 from "../assets/img/team/profile-picture-3.jpg";


export default () => {
  const { currentUser, isAdmin } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [hasAdminClaim, setHasAdminClaim] = useState(false);

  const checkAdminClaim = async () => {
    if (!currentUser) return;
    const token = await currentUser.getIdTokenResult();
    setHasAdminClaim(token.claims.admin === true);
  };

  React.useEffect(() => {
    checkAdminClaim();
  }, [currentUser]);

  const setAdminClaims = async () => {
    if (!currentUser) return;
    
    setLoading(true);
    setMessage(null);

    try {
      const functions = getFunctions();
      const setAdminClaimsFunction = httpsCallable(functions, 'setAdminClaims');
      
      const result = await setAdminClaimsFunction({ uid: currentUser.uid });
      
      if (result.data.success) {
        setMessage({ type: 'success', text: 'Admin yetkisi başarıyla verildi! Sayfayı yenileyin.' });
        setHasAdminClaim(true);
        
        // Token'ı yenile
        await currentUser.getIdToken(true);
      } else {
        setMessage({ type: 'danger', text: result.data.message || 'Hata oluştu' });
      }
    } catch (error) {
      console.error('Error setting admin claims:', error);
      setMessage({ type: 'danger', text: 'Hata: ' + error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Firebase Auth Custom Claims Uyarısı */}
      {currentUser && !hasAdminClaim && (
        <Alert variant="warning" className="mb-4">
          <h5><FontAwesomeIcon icon={faUserShield} className="me-2" />Firebase Auth Admin Yetkisi Eksik</h5>
          <p className="mb-3">
            Firestore'da admin olarak tanımlı olsanız da, Firebase Auth token'ınızda admin claim'i bulunmuyor. 
            Bu nedenle bazı işlemler (cevapsız mesajlar, vb.) "Missing or insufficient permissions" hatası verebilir.
          </p>
          <Button 
            variant="primary" 
            onClick={setAdminClaims} 
            disabled={loading}
          >
            {loading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="fa-spin me-2" />
                Admin Yetkisi Veriliyor...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faUserShield} className="me-2" />
                Admin Yetkisi Ver
              </>
            )}
          </Button>
          {message && (
            <Alert variant={message.type} className="mt-3 mb-0">
              {message.text}
            </Alert>
          )}
        </Alert>
      )}

      {currentUser && hasAdminClaim && (
        <Alert variant="success" className="mb-4">
          <FontAwesomeIcon icon={faUserShield} className="me-2" />
          Firebase Auth admin yetkisi aktif! Tüm özelliklere erişebilirsiniz.
        </Alert>
      )}

      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <Dropdown>
          <Dropdown.Toggle as={Button} variant="secondary" className="text-dark me-2">
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            <span>New</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-2">
            <Dropdown.Item>
              <FontAwesomeIcon icon={faFileAlt} className="me-2" /> Document
            </Dropdown.Item>
            <Dropdown.Item>
              <FontAwesomeIcon icon={faCommentDots} className="me-2" /> Message
            </Dropdown.Item>
            <Dropdown.Item>
              <FontAwesomeIcon icon={faBoxOpen} className="me-2" /> Product
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item>
              <FontAwesomeIcon icon={faRocket} className="text-danger me-2" /> Subscription Plan
              </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <div className="d-flex">
          <Dropdown>
            <Dropdown.Toggle as={Button} variant="primary">
              <FontAwesomeIcon icon={faClipboard} className="me-2" /> Reports
              <span className="icon icon-small ms-1"><FontAwesomeIcon icon={faChevronDown} /></span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-1">
              <Dropdown.Item>
                <FontAwesomeIcon icon={faBoxOpen} className="me-2" /> Products
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faStore} className="me-2" /> Customers
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faCartArrowDown} className="me-2" /> Orders
              </Dropdown.Item>
              <Dropdown.Item>
                <FontAwesomeIcon icon={faChartPie} className="me-2" /> Console
              </Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item>
                <FontAwesomeIcon icon={faRocket} className="text-success me-2" /> All Reports
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <Row>
        <Col xs={12} xl={8}>
          <GeneralInfoForm />
        </Col>

        <Col xs={12} xl={4}>
          <Row>
            <Col xs={12}>
              <ProfileCardWidget />
            </Col>
            <Col xs={12}>
              <ChoosePhotoWidget
                title="Select profile photo"
                photo={Profile3}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
